import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const TabPanel = ({ children, className, isSelected }) => {
  const panelClassName = classnames(className, {
    'is-active': isSelected
  })
  return <div className={panelClassName}>{children}</div>
}

TabPanel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  isSelected: PropTypes.bool
}

TabPanel.defaultProps = {
  children: null,
  className: null,
  isSelected: false
}

export default TabPanel
